import React from 'react';
import { Grid } from '@mui/material';
import { Seo } from 'src/components/seo';
import {
  E2eLogicObjectsWithAasoParams,
  e2eLogicUtils_getRoutingLogicObjects,
} from 'src/e2e-redesign/business-logic/e2e-logic-utils';
import {
  selectAppLogic_functionsAndVals,
  selectAppLogic_init,
} from 'src/e2e-redesign/views/SelectedApplicationType/logic/select-app-logic';
import { E2eAppSettingsFormPathsI } from 'src/interfaces/application-settings.interfaces';

import PageIntro from '../../components/PageIntro';
import ProviderDetailsDrawer from '../../components/ProviderDetailsDrawer/ProviderDetailsDrawer';
import ThemedContainer from '../../components/ThemedContainer';
import ApplicationCard from './ApplicationCard';

export default function SelectApplicationType() {
  const routingPackage: E2eLogicObjectsWithAasoParams = e2eLogicUtils_getRoutingLogicObjects();
  selectAppLogic_init(routingPackage);
  const fnv = selectAppLogic_functionsAndVals(routingPackage);
  const { toggleDrawer, handleSelectPathType } = fnv.fn;
  const { drawerStates, e2ePaths } = fnv.v;

  return (
    <>
      <Seo title="Pathway" />
      <ThemedContainer>
        <PageIntro
          title="Please select your preferred pathway to proceed."
          paragraph="Review program details below and choose the path that suits you best. Keep in mind: your application may be sent to multiple payment options. Our goal is to connect you with the right payment option."
        />
        <Grid container spacing={3}>
          {e2ePaths.map((path: E2eAppSettingsFormPathsI, index) => (
            <>
              <Grid item xs={12} md={6}>
                <ApplicationCard
                  path={path}
                  title={path.name}
                  notice={path.description}
                  buttonText={path.button_text}
                  onDetailsClick={toggleDrawer(index)}
                  handleSelectPathType={() => handleSelectPathType(path)}
                />
              </Grid>
              <ProviderDetailsDrawer
                isDrawerOpen={drawerStates[index]}
                path={path}
                toggleDrawer={toggleDrawer(index)}
                showPathName={true}
              />
            </>
          ))}
        </Grid>
      </ThemedContainer>
    </>
  );
}
